import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-word-break-all" }

import { computed } from "vue";
import { ErrorModalProps } from "@/types";
import { appStore } from "@/hooks";
import { List, ListItem } from "@/components/common/display";
import Modal from "./Modal.vue";


/**
 * Renders server errors.
 */
const __default__ = {
  name: "ServerErrorModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    errors: {}
  },
  setup(__props: any) {

const props = __props;

const open = computed(() => appStore.popups.errorModal);

/**
 * Closes the error display.
 */
function handleClose() {
  appStore.toggle("errorModal");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    title: "Server Errors",
    open: open.value,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(List), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
            return (_openBlock(), _createBlock(_unref(ListItem), { key: error }, {
              default: _withCtx(() => [
                _createElementVNode("code", _hoisted_1, _toDisplayString(error), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})